export default __webpack_public_path__ + "static/media/Flag of Saint Pierre and Miquelon.e6a200b7.gif";